/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-19 11:19:45
 * @FilePath: /unifyxp-v2-store-portal/src/pages/InventoryList/InventoryListConfig.tsx
 */
import { EnumProductType, EnumStatus } from 'src/types/common/product';

import { EnumFilterType } from 'src/constrains/Query1/Filter';

const sortList = ({ getI18n }) => [
  //排序下拉列表配置
  {
    label: getI18n('inventory.inventory.list_inventoryListConfig_sku_asc'),
    value: 1,
    data: { field: 'sku', ascent: true },
  },
  {
    label: getI18n('inventory.inventory.list_inventoryListConfig_sku_desc'),
    value: 2,
    data: { field: 'sku', ascent: false },
  },
  {
    label: getI18n(
      'inventory.inventory.list_inventoryListConfig_adjust_newest',
    ),
    value: 3,
    data: { field: 'createdDate', ascent: false },
  },
  {
    label: getI18n(
      'inventory.inventory.list_inventoryListConfig_adjust_Oldest',
    ),
    value: 4,
    data: { field: 'createdDate', ascent: true },
  },
  {
    label: getI18n(
      'inventory.inventory.list_inventoryListConfig_stock_highest',
    ),
    value: 5,
    data: { field: 'stockQuantity', ascent: false },
  },
  {
    label: getI18n('inventory.inventory.list_inventoryListConfig_stock_lowest'),
    value: 6,
    data: { field: 'stockQuantity', ascent: true },
  },
];
const filterList = (supplierList, { getI18n }) => {
  return [
    {
      type: EnumFilterType.MultipleSelection,
      dropdownProps: { name: getI18n('general.sider.salesChannel') },

      keyWord: 'salesChannel',
      options: [
        //定义排序所需的数据
        {
          label: getI18n(
            'inventory.inventory.list_inventoryListConfig_filterList_salesChannel_h5',
          ),
          value: 'h5',
        },
        {
          label: getI18n(
            'inventory.inventory.list_inventoryListConfig_filterList_salesChannel_Desktop',
          ),
          value: 'desktop',
        },
        {
          label: getI18n(
            'inventory.inventory.list_inventoryListConfig_filterList_salesChannel_Wholesale',
          ),
          value: 'wholeSales',
        },
      ],
    },

    {
      type: EnumFilterType.MultipleSelection,
      dropdownProps: { name: getI18n('general.type') },
      keyWord: 'productTypes',
      options: [
        //定义排序所需的数据
        { label: getI18n('general.simple'), value: EnumProductType.Simple },
        { label: getI18n('general.set'), value: EnumProductType.Set },
        // { label: 'Service', value: EnumProductType.Service },
        // { label: 'Gift Card', value: EnumProductType.GiftCard },
      ],
    },
    {
      type: EnumFilterType.MultipleSelection,
      dropdownProps: { name: getI18n('inventory.inventory.supplier') },
      keyWord: 'supplierUuid',
      options: supplierList.map((item) => ({
        label: item.name,
        value: item.uuid,
      })),
    },
    {
      type: EnumFilterType.MultipleSelection,
      dropdownProps: { name: getI18n('inventory.inventory.productStatus') },
      keyWord: 'productStatuses',
      options: [
        { label: getI18n('general.status.active'), value: EnumStatus.Active },
        { label: getI18n('general.status.draft'), value: EnumStatus.Draft },
        {
          label: getI18n(
            'inventory.inventory.list_inventoryListConfig_filterList_productStatuses_archived',
          ),
          value: EnumStatus.Archived,
        },
      ],
    },
  ];
};

export { filterList, sortList };
